import { Form, Modal, ModalProps, Select, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../components/form-item'
import useForm from '../../hooks/use-form'
import { useInviteClients } from '../hooks'
import { useCampaigns } from '../../campaign/hooks'

type ClientInviteModalProps = {
    companyId?: string
} & ModalProps

export function ClientInviteModal({ companyId, ...rest }: ClientInviteModalProps) {
    const { t } = useTranslation()

    const mutation = useInviteClients(companyId)
    const campaignsQuery = useCampaigns({
        query: {
            size: 1000,
        },
    })

    const formProps = useForm({
        mutation,
        onSuccess: () => {
            formProps.form.resetFields()
            rest?.onCancel?.({} as never)
        },
    })

    const campaignOptions = (campaignsQuery.data?.data ?? []).map((campaign) => ({
        value: campaign.id,
        label: campaign.title,
    }))

    return (
        <Modal
            {...rest}
            title={t('Invite clients')}
            onOk={() => formProps.form.submit()}
            okText={t('Invite')}
            okButtonProps={{
                loading: mutation.isPending,
            }}
        >
            <Typography.Text className="mb-4 block">
                {t(
                    'Invite a client to view specific campaigns. They will receive read-only access to the campaigns you assign.'
                )}
            </Typography.Text>
            <Form
                layout="vertical"
                {...formProps}
            >
                <FormItem
                    label={t('Email')}
                    name="emails"
                    required
                >
                    <Select
                        mode="tags"
                        open={false}
                        suffixIcon={<></>}
                        tokenSeparators={[',', ' ']}
                        placeholder={t('Enter client emails')}
                    />
                </FormItem>
                <FormItem
                    label={t('Campaigns')}
                    name="campaignIds"
                    help={t('The client will only be able to view these campaigns.')}
                >
                    <Select
                        mode="multiple"
                        placeholder={t('Select campaigns')}
                        maxTagCount={1}
                        options={campaignOptions}
                        loading={campaignsQuery.isPending}
                        optionFilterProp="label"
                    />
                </FormItem>
            </Form>
        </Modal>
    )
}
